export default "__VITE_ASSET__Q2YWN$G$__"